import React, { useState } from "react";
import { TextField, Button, Typography, Box } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

const StepLogin = ({
  loginUsername,
  loginPassword,
  setLoginUsername,
  setLoginPassword,
  handleLogin,
  setShowLogin,
  setStep,
  loading,
}) => {
  const [error, setError] = useState({ username: false, password: false });

  const onSubmit = () => {
    const isUsernameEmpty = loginUsername.trim() === "";
    const isPasswordEmpty = loginPassword.trim() === "";

    setError({
      username: isUsernameEmpty,
      password: isPasswordEmpty,
    });

    if (!isUsernameEmpty && !isPasswordEmpty) {
      handleLogin();
    }
  };

  return (
    <div style={{ display: "flex", gap: "10px", flexDirection: "column" }}>
      <Box textAlign="center" mb={1}>
        <PersonIcon fontSize="large" color="primary" />
      </Box>
      <h2>Login to your account</h2>

      <TextField
        fullWidth
        label="User Name"
        value={loginUsername}
        onChange={(e) => setLoginUsername(e.target.value)}
        margin="normal"
        size="small"
        error={error.username}
        helperText={error.username ? "Username is required" : ""}
      />

      <TextField
        fullWidth
        label="Password"
        type="password"
        value={loginPassword}
        onChange={(e) => setLoginPassword(e.target.value)}
        margin="normal"
        size="small"
        error={error.password}
        helperText={error.password ? "Password is required" : ""}
      />

      <Button variant="contained" fullWidth sx={{ mt: 1 }} onClick={onSubmit}>
        {loading ? "Loading..." : "   Login"}
      </Button>

      <Typography variant="body2" textAlign="center" sx={{ mt: 1 }}>
        Don’t have an account?{" "}
        <span
          style={{
            color: "#1976d2",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={() => setShowLogin(false)}
        >
          Register here
        </span>
      </Typography>

      <Typography
        variant="body2"
        sx={{ textAlign: "right", mt: 1, cursor: "pointer", color: "#1976d2" }}
        onClick={() => setStep("forgotEmail")}
      >
        Forgot Password?
      </Typography>
    </div>
  );
};

export default StepLogin;
